// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fGsXB","tabsBox":"styles_tabsBox__SS2Yy","createButton":"styles_createButton__2GCRY"};